/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 * Fieldset panel component.
 */
import React, { Component } from 'react';
import { v1 } from 'node-uuid';

class Fieldset extends Component {

    constructor() {
        super();
        this.id = v1();
    }

    render() {
        const { legend, children, contentClass } = this.props;

        return (
            <div className={contentClass}>
                <fieldset >
                    <legend>
                        <a
                            data-toggle="collapse"
                            data-target={`#${this.id}`}
                            style={{ cursor: 'pointer' }}
                        >
                            <h5>{legend}</h5>
                        </a>
                    </legend>
                    <div className="col collapse in" id={this.id}>
                        {children}
                    </div>
                </fieldset>
            </div>
        );
    }
}

export default Fieldset;



// WEBPACK FOOTER //
// ./components/layout/fieldset.js